import React, { useContext, useEffect, useState } from 'react'
import { mapData } from '../../../../product/common/components'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import UserContext from '../../../../product/context/user/userContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AuthContext from '../../../../product/context/auth/authContext'
import Popup from '../Popup'

function UpdateUserName(props) {
    const authContext = useContext(AuthContext)
    const userContext = useContext(UserContext)
    const { user, isAuthenticated, loadUser } = authContext
    const { updateProfile, responseStatus: responseStatusUser } = userContext

    const [disabled, setDisabled] = useState(false)
    const [reload, setReload] = useState(false)

    const validationArray = Yup.object({
        first_name: Yup.string()
            .trim()
            .max(30, 'Maximum 30 charaters')
            .min(2, 'Minimum 2 characters')
            .required('Required!'),
        last_name: Yup.string()
            .trim()
            .max(30, 'Maximum 30 charaters')
            .min(2, 'Minimum 2 characters')
            .required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            first_name: '',
            last_name: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            const castValues = validationArray.cast(values)
            updateProfile(castValues)
        },
    })

    const profile = [
        {
            label: 'First name',
            placeholder: 'Enter your first name',
            class: 'col-md-12',
            type: 'text',
            name: 'first_name',
            formik: formik,
        },
        {
            label: 'Last name',
            placeholder: 'Enter your last name',
            class: 'col-md-12',
            type: 'text',
            name: 'last_name',
            formik: formik,
        },
    ]

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from === 'updateProfile') {
                if (responseStatusUser.status === 'success') {
                    loadUser()
                    props.function(false, 'new', null)
                    setTimeout(() => {
                        props.data.onDismiss?.()
                    }, 750)
                }
            }
        }
    }, [responseStatusUser])
    return (
        <>
            <Popup
                open={
                    props.data.popup &&
                    (props.data.status === 'new' || props.data.status === 'update')
                }
                size="md"
                handleClose={() => props.function(false, 'new', null)}
                modaltitle="Update Your Name"
            >
                <div className="addressInfo">
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        {mapData(profile)}
                        <div className="col-12">
                            <PrimaryButton
                                // disabled={disabled}
                                btnSize="large"
                                type="submit"
                                label={'Save'}
                            />
                        </div>
                    </form>
                </div>
            </Popup>
        </>
    )
}

export default UpdateUserName
